var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShieldWithClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 85,
    viewBox: "0 0 62 85",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L29 0 29 29 0 29z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M54.032 45.862c0 10.685-5.989 18.558-23.49 30.46C13.04 64.42 7.05 56.547 7.05 45.861V18.775c8.704-.925 15.67-3.887 23.49-9.934 7.82 6.047 14.788 9.009 23.491 9.933v27.088zm5.138-33.525c-10.294-.233-17.372-2.711-27.343-11.2C31.47.834 31.004.68 30.541.68c-.465 0-.928.153-1.286.457-9.968 8.489-17.046 10.967-27.341 11.2C.968 12.358.2 13.112.2 14.043v31.82C.2 61.33 10.707 71.34 29.117 83.528c.392.26.909.39 1.424.39.517 0 1.032-.13 1.424-.39 18.41-12.188 28.918-22.198 28.918-37.667V14.043c0-.931-.767-1.685-1.713-1.706z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M12.383 18.244l-3.088-3.067-1.537 1.526 4.61 4.578 8.7-8.638-1.537-1.527-7.148 7.128zM14.5 26.12c-5.611 0-10.15-4.507-10.15-10.08 0-5.572 4.539-10.079 10.15-10.079 5.611 0 10.15 4.507 10.15 10.08 0 5.572-4.538 10.08-10.15 10.08zm0-23.039c-7.207 0-13.05 5.803-13.05 12.96C1.45 23.196 7.279 29 14.5 29c7.206 0 13.05-5.804 13.05-12.96 0-7.156-5.844-12.959-13.05-12.959zm-5.974-.878L6.67 0 0 5.544l1.87 2.203 6.656-5.544zM29 5.558L22.33 0l-1.87 2.203 6.67 5.558L29 5.558z",
    mask: "url(#prefix__b)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShieldWithClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield_with_clock.f3e21dbc.svg";
export { ForwardRef as ReactComponent };